import React, { useContext } from 'react';
import Switch from "react-switch";
import { HexColorPicker } from "react-colorful";
import ThemeContext from '../contexts/ThemeContext';

interface ThemeMenuProps { };

const ThemeMenu: React.FC<ThemeMenuProps> = () => {
  const {
    backgroundColorHex,
    showBubbles,
    updateBackgroundColorHex,
    updateShowBubbles
  } = useContext(ThemeContext);

  return (
    <>
      <div className='flex flex-col items-center justify-center'>
        <p className='font-mono'>
          bg color
        </p>
        <HexColorPicker onChange={newColor => updateBackgroundColorHex(newColor)} color={backgroundColorHex} />
      </div>
      <div className='flex items-center justify-center mt-4'>
        <p className='font-mono'>
          show bubbles
        </p>
        <Switch
          onColor='#86a3ff'
          checked={showBubbles}
          onChange={checked => updateShowBubbles(checked)}
          className='ml-3'
        />
      </div>
    </>
  );
}

export default ThemeMenu;
